import {Order, Plan} from 'grpc-bob/subscription_pb';
import {StudentProfile} from 'grpc-bob/student_pb';

import {
  AppActions,
  IPromotion,
  PackageWithPromotion,
  SET_CHOSEN_PACKAGE,
  SET_LOADING,
  SET_MESSAGE,
  SET_ORDERS,
  SET_PACKAGES,
  SET_PARTIAL_STATE, SET_PAYMENT_ORDER_ID,
  SET_PLAN_ID,
  SET_PLANS,
  SET_PROMOTION,
  SET_PROMOTION_EFFECT,
  SET_SUMMARY,
  SET_TOKEN,
  SET_USER,
  // SET_PAYMENT_URL,
  SET_ORDER_WAITING_PAYMENT
} from './types';
import {AppState} from './reducer';


export function setLoading(loadingState: boolean): AppActions {
  return {
    type: SET_LOADING,
    payload: loadingState
  }
}

export function setToken(token: string): AppActions {
  return {
    type: SET_TOKEN,
    payload: token
  }
}

export function setPlanId(planId: string): AppActions {
  return {
    type: SET_PLAN_ID,
    payload: planId
  }
}

export function setPlans(plans: Plan.AsObject[]): AppActions {
  return {
    type: SET_PLANS,
    payload: plans
  }
}

export function setPackages(packages: PackageWithPromotion[]): AppActions {
  return {
    type: SET_PACKAGES,
    payload: packages
  }
}

export function setMessage(message: string): AppActions {
  return {
    type: SET_MESSAGE,
    payload: message
  }
}

export function setUser(user: StudentProfile.AsObject): AppActions {
  return {
    type: SET_USER,
    payload: user
  }
}

export function setChosenPackage(pack: PackageWithPromotion | null): AppActions {
  return {
    type: SET_CHOSEN_PACKAGE,
    payload: pack
  }
}

export function setSummary(order: Order.AsObject, user: StudentProfile.AsObject): AppActions {
  return {
    type: SET_SUMMARY,
    payload: {
      order,
      user,
    }
  }
}
export function setOrderWaitingPayment(order: Order.AsObject): AppActions {
  return {
    type: SET_ORDER_WAITING_PAYMENT,
    payload: order
  }
}


//
// export function setActiveOrder(order: Order.AsObject) : AppActions {
//   return {
//     type: SET_ACTIVE_ORDER,
//     payload: order
//   }
// }

export function setOrders(orders: Order.AsObject[]): AppActions {
  return {
    type: SET_ORDERS,
    payload: orders
  }
}

export function setPromotion(promotion: Partial<IPromotion>): AppActions {
  return {
    type: SET_PROMOTION,
    payload: promotion
  }
}

export function setPromotionEffect(packages: PackageWithPromotion[], chosenPackage: PackageWithPromotion | null, promotion: IPromotion): AppActions {
  return {
    type: SET_PROMOTION_EFFECT,
    payload: {
      packages,
      chosenPackage,
      promotion
    }
  }
}

export function setPartialState(state: Partial<AppState>): AppActions {
  return {
    type: SET_PARTIAL_STATE,
    payload: state
  }
}

export function setPaymentOrderId(orderId: number | null) {
  return {
    type: SET_PAYMENT_ORDER_ID,
    payload: orderId
  }
}

//
// export function setInitialData(initData: InitialPayload) : AppActions {
//   return {
//     type: SET_INITIAL_DATA,
//     payload: initData
//   }
// }

// export function setPaymentUrl(paymentUrl: string): AppActions {
//   return {
//     type: SET_PAYMENT_URL,
//     payload: paymentUrl
//   }
// }
